import { Alert, Button, Form, Input, message, Modal } from 'antd';
import React, { useState } from 'react';
import { excludeDomains } from 'services/api/domains';

const DomainExclusionModal = ({ isOpen, onClose, domain }) => {
  const [loading, setLoading] = useState(false);
  const onFinish = (values) => {
    if (values && values.exclusionList && values.exclusionList.length > 0) {
      setLoading(true);
      excludeDomains({
        name: domain.name,
        exclusionList: values.exclusionList.split(','),
      })
        .then(() => {
          message.success('Exclusion list saved');
          onClose();
        })
        .catch((e) => {
          message.error('Error saving exclusion list');
          console.error(e);
        })
        .finally(() => {
          setLoading(false);
        });
    } else return;
  };
  return (
    <Modal
      title="Exclude domains"
      open={isOpen}
      onCancel={onClose}
      footer={null}
    >
      <div>
        Enter domains with whom you've already exchanged links to make sure
        you're not matched with them.
      </div>
      <div style={{ marginTop: 12 }}>
        <Alert
          showIcon={true}
          message="You can export the exclusion list to a CSV file in tools like ahref."
          type="info"
        />
      </div>
      <div style={{ marginTop: 24 }}>
        <Form
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            exclusionList: domain.exclusionList,
          }}
        >
          <Form.Item name="exclusionList" label="Domains (separated by commas: example.com)">
            <Input.TextArea />
          </Form.Item>
          <Form.Item>
            <Button block type="primary" htmlType="submit" loading={loading}>
              Save exclusion list
            </Button>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default DomainExclusionModal;
